import DataTable from "components/DataTable";
import { ReactNode } from "react";
interface Column {
  key: string;
  label: string;
  actions?: (row: Row) => React.ReactNode;
  excludeExport?: boolean;
}
interface Row {
  id: number;
  [key: string]: ReactNode;
}
interface FormersProps {
  data: Row[];
  columns: Column[];
  itemsPerPage?: number;
  loading?: boolean;
  onAdd?: () => void;
  title?: string;
}

const Farmers = ({ data, columns, loading, onAdd, title, itemsPerPage }: FormersProps) => {
  return (
    <div>
      <DataTable
        data={data}
        columns={columns}
        title={title}
        loading={loading}
        onAddBtnClick={onAdd}
        itemsPerPage={itemsPerPage}
      ></DataTable>
    </div>
  );
};
export default Farmers;
